import script from "./SpendingFilterTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingFilterTabs.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingFilterTabs.vue?vue&type=style&index=0&id=2b88ea42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b88ea42"]])

export default __exports__